<template>
  <div>
    <v-data-table
      ref="table"
      v-model="selectedValue"
      :items="items"
      :headers="headers"
      :items-per-page="-1"
      disable-sort
      disable-pagination
      hide-default-footer
      show-select
      dense
      height="200"
      :item-selected="$emit('select', selectedValue)"
    >
      <template #[`item.isSettled`]="{ item }">
        <v-btn v-if="item.isSettled" icon small>
          <v-icon small color="primary">$checkboxOn</v-icon>
        </v-btn>
        <v-btn v-else icon small>
          <v-icon small color="primary">$checkboxOff</v-icon>
        </v-btn>
      </template>
      <template #[`item.isSended`]="{ item }">
        <v-btn v-if="item.isSended" icon small>
          <v-icon small color="primary">$checkboxOn</v-icon>
        </v-btn>
        <v-btn v-else icon small>
          <v-icon small color="primary">$checkboxOff</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Prop, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";
import { RelatedDocument } from "@/models/api/costDocuments/RelatedDocument";

@Component
export default class CostDocumentVirtualPopupTable extends Vue {
  @Prop({ required: true })
  relatedDocuments!: RelatedDocument[];

  get items() {
    return this.relatedDocuments;
  }

  selectedValue: number[] = [];

  headers: DataTableHeader[] = [
    {
      text: filterCapitalize(i18n.t("documentNumber")),
      value: "documentNumber",
    },
    {
      text: filterCapitalize(i18n.t("isSettled")),
      value: "isSettled",
    },
    {
      text: filterCapitalize(i18n.t("isSended")),
      value: "isSended",
    },
  ];

  //Default select all items
  mounted() {
    const table = this.$refs.table as HTMLFormElement & Vue;
    table.toggleSelectAll(true);
  }
}
</script>

<style lang="scss"></style>
